<template>
  <div class="integralDetail b_white">
    <div class="integral_total b_red">
      <p class="t_right white mar10_b" @click="getRule">{{shopPoints.pointsName}}规则</p>
      <p class="white f16_rem mar10_b lin_30">
        <span class="f30_rem">{{shopPoints.points}}</span> {{shopPoints.pointsName}}
      </p>
      <p class="white">{{shopPoints.pointsName}}可在下单时进行抵扣</p>
    </div>
    <van-list
      :loading="loading"
      :finished="finished"
      :offset="20"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <ul>
        <li>
          <div class="w30 gray_3 fb">{{shopPoints.pointsName}}</div>
          <div class="flex_1 gray_3 fb">来源/用途</div>
          <div class="gray_3 fb w138">时间</div>
        </li>
        <li v-for="record in allRecordList" :key="record.id">
          <div class="w30 ellipsis">
            {{ (record.type === 1 || record.type === 4) ? '+' : '-'}}{{record.usedPoints}}
          </div>
          <div class="flex_1 ellipsis">{{record.ptTypeName}}</div>
          <span class="w138">{{record.createDate}}</span>
        </li>
      </ul>
    </van-list>
    <div class="detail_btn">
      <span @click="toGivePoints">{{shopPoints.pointsName}}转赠</span>
    </div>
  </div>
</template>
<script>

import { Toast } from "vant";
import { mapState } from "vuex";
import common from "@/assets/js/common";

export default {
  data() {
    return {
      shopId: "",
      finished: false,
      loading: false,
      allRecordList: [],
      pageNum: 1,
      pageSize: 10,
      shopPoints: {
        points: 0,
        pointsName: "积分",
        rule: ""
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.shopId = this.$route.query.shopId;
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getMyPoints();
    this.getMyPointsRecord(true);
  },
  methods: {
    getRule() {
      const url = `/integral/ruleDetail?shopId=${this.shopId}`;
      this.$router.push(url);
    },
    getMyPoints() {
      const params = {
        shopId: this.shopId,
        pageNum: 1,
        pageSize: 1
      };
      this.$store.dispatch("shop/shopPoints/getMyPointsList", params).then((data) => {
        const newData = data || {};
        const list = newData.list || [];
        if (list.length > 0) {
          this.shopPoints = list[0]; //eslint-disable-line
          document.title = `${this.shopPoints.pointsName}明细`;
        } else {
          this.getPointsRule();
        }
      }).catch(() => {
      });
    },
    getPointsRule() {
      const params = {
        shopId: this.shopId
      };
      this.$store.dispatch("shop/shopPoints/getPointsRule", this.$qs.stringify(params)).then((data) => {
        const newData = data || {};
        this.shopPoints = {
          points: 0,
          pointsName: newData.name,
          rule: newData.rule
        };
        document.title = `${this.shopPoints.pointsName}明细`;
      }).catch(() => {
      });
    },
    onLoad() {
      this.loading = true;
      this.clickToMore();
    },
    // 加载更多
    clickToMore() {
      this.pageNum = this.pageNum + 1;
      this.getMyPointsRecord(false);
    },
    getMyPointsRecord(load) {
      if (load === true) {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
      }
      const params = {
        shopId: this.shopId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$store.dispatch("shop/shopPoints/getMyPointsRecord", params).then((data) => {
        Toast.clear();
        const newData = data || {};
        const list = newData.list || [];
        // 加载状态结束
        this.loading = false;
        // 加载更多
        this.allRecordList = [...this.allRecordList, ...list];
        if (list.length === 0) {
          this.finished = true;
        }
      }).catch(() => {
        Toast.clear();
      });
    },
    toGivePoints() {
      this.$router.push({
        path: "/integral/gift",
        query: {
          shopId: this.shopId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
